import { render } from "./ContentRadio.vue?vue&type=template&id=5583d724"
import script from "./ContentRadio.vue?vue&type=script&lang=js"
export * from "./ContentRadio.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__